<div class="toggle-switch" (click)="toggleSwitch($event)">
</div>
